const RenderGate = ({ shouldRender, children }) => (shouldRender ? children : null);

export default RenderGate;